import { Dispatch } from "@reduxjs/toolkit";
import { api } from "../config/api";
import { GetState } from "../config/store";
import {
    getMyPublicationsFailure,
    getMyPublicationsSuccess,
    cleanMyPublications as cleanMyPublicationsReducer,
    getMyPublicationsRequest as getMyPublicationsRequestReducer,
    getMyBuysSuccess,
    getMyBuysFailure,
    getMyBuysRequest as getMyBuysRequestReducer,
    cleanMyBuys as cleanMyBuysReducer,
    getMyBuyRequest,
    getMyBuySuccess,
    getMyBuyFailure,
    cleanMyBuy as cleanMyBuyReducer,
    getRegionsRequest,
    getRegionsSuccess,
    getRegionsFailure,
    getCitiesRequest,
    getCitiesSuccess,
    getCitiesFailure,
    getCommunesRequest,
    getCommunesSuccess,
    getCommunesFailure,
    getFavoritesRequest,
    getFavoritesSuccess,
    getFavoritesFailure,
    cleanFavorites as cleanFavoritesReducer,
    setFavorites as setFavoritesReducer,
    likePublicationRequest,
    likePublicationSuccess,
    likePublicationFailure,
    dislikePublicationRequest,
    dislikePublicationSuccess,
    dislikePublicationFailure,
    cleanLikePublication as cleanLikePublicationReducer,
    setPublication,
    getCreditDataRequest,
    getCreditDataSuccess,
    getCreditDataFailure,
    getPaymentsRequest,
    getPaymentsSuccess,
    getPaymentsFailure,
    cleanPayments as cleanPaymentsReducer,
    postPaymentDocumentRequest,
    postPaymentDocumentSuccess,
    postPaymentDocumentFailure,
    postPaymentRequest,
    postPaymentSuccess,
    postPaymentFailure,
    cleanPayment as cleanPaymentReducer,
    getSchedulesRequest,
    getSchedulesSuccess,
    getSchedulesFailure,
    cleanSchedules as cleanSchedulesReducer,
    putTransferPublicationRequest,
    putTransferPublicationSuccess,
    putTransferPublicationFailure,
    cleanTransferPublication as cleanTransferPublicationReducer,
    getBranchesTransferRequest,
    getBranchesTransferSuccess,
    getBranchesTransferFailure,
    cleanBranchesTransfer as cleanBranchesTransferReducer,
    getBranchesRequest,
    getBranchesSuccess,
    getBranchesFailure,
    cleanBranches as cleanBranchesReducer,
    addBranchRequest,
    addBranchSuccess,
    addBranchFailure,
    cleanAddBranch as cleanAddBranchReducer,
    editBranchRequest,
    editBranchSuccess,
    editBranchFailure,
    cleanEditBranch as cleanEditBranchReducer,
    deleteBranchRequest,
    deleteBranchSuccess,
    deleteBranchFailure,
    cleanDeleteBranch as cleanDeleteBranchReducer,
    getSellersTransferRequest,
    getSellersTransferSuccess,
    getSellersTransferFailure,
    cleanSellersTransfer as cleanSellersTransferReducer,
    getSellersRequest,
    getSellersSuccess,
    getSellersFailure,
    cleanSellers as cleanSellersReducer,
    addSellerRequest,
    addSellerSuccess,
    addSellerFailure,
    cleanAddSeller as cleanAddSellerReducer,
    editSellerRequest,
    editSellerSuccess,
    editSellerFailure,
    cleanEditSeller as cleanEditSellerReducer,
    deleteSellerRequest,
    deleteSellerSuccess,
    deleteSellerFailure,
    cleanDeleteSeller as cleanDeleteSellerReducer,
    getBranchRequest,
    getBranchSuccess,
    getBranchFailure,
    cleanBranch as cleanBranchReducer,
    getMyOffersRequest,
    getMyOffersSuccess,
    getMyOffersFailure,
    cleanGetMyOffers as cleanGetMyOffersReducer
} from "../reducers/profile";
import {
    patchResidenceRequest,
    patchResidenceSuccess,
    patchResidenceFailure,
    cleanResidenceFetching,
    getConcessionaryRequest,
    getConcessionarySuccess,
    getConcessionaryFailure,
    cleanConcessionary as cleanConcessionaryReducer
} from "../reducers/auth";
import {
    cleanEditUser
} from "../reducers/auth";
import { ResidenceProps } from '../interfaces';
import { axiosClient } from "../config/axios";
import { catch401 } from "../helpers/actions";

export const getMyPublicationsRequest = (page: number = 1, limit: number = 20, condition?: string) => (dispatch: Dispatch, getState: GetState) => _getMyPublicationsRequest(page, limit, dispatch, getState, condition);
const _getMyPublicationsRequest = async (page: number = 1, limit: number = 20, dispatch: Dispatch, getState: GetState, condition?: string) => {
    try {
        dispatch({ type: getMyPublicationsRequestReducer })

        const response = await axiosClient.get(`${api.publications}/my-publications?limit=${limit}&page=${page}${condition === 'new' ? `&condition=${condition}` : ""}`);

        dispatch({ 
            type: getMyPublicationsSuccess, 
            payload: { 
                publications: response?.data.data.publications, 
                total: response?.data.data.total 
            } 
        });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getMyPublicationsFailure });
    }
};

export const cleanMyPublications = () => (dispatch: Dispatch) => _cleanMyPublications(dispatch);
const _cleanMyPublications = (dispatch: Dispatch) => dispatch({ type: cleanMyPublicationsReducer });

export const getMyPublicationsBrandRequest = (
    brandId: string,
    page: number = 1,
    limit: number = 20,
  ) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: getMyPublicationsRequestReducer });
  
      const queryParams = new URLSearchParams({
        limit: limit.toString(),
        page: page.toString(),
      });
  
      const response = await axiosClient.get(
        `${api.publications}/brand-publications/my-publications?${queryParams}`
      );
  
      dispatch({
        type: getMyPublicationsSuccess,
        payload: {
          publications: response?.data.data.publications,
          total: response?.data.data.total,
        },
      });
    } catch (error: any) {
      const errorResponse = error?.response?.data?.error;
      console.log(errorResponse?.code);
      catch401(errorResponse?.code, dispatch);
      dispatch({ type: getMyPublicationsFailure });
    }
  };

export const cleanMyPublicationsBrand = () => (dispatch: Dispatch) => _cleanMyPublicationsBrand(dispatch);
const _cleanMyPublicationsBrand = (dispatch: Dispatch) => dispatch({ type: cleanMyPublicationsReducer });


export const getMyBuysRequest = (page: number = 1, limit: number = 20) => (dispatch: Dispatch) => _getMyBuysRequest(page, limit, dispatch);
const _getMyBuysRequest = async (page: number = 1, limit: number = 20, dispatch: Dispatch) => {
    try {
        dispatch({ type: getMyBuysRequestReducer })

        const response = await axiosClient.get(`${api.transactions}?type=purchase&page=${page}&limit=${limit}`);

        dispatch({ 
            type: getMyBuysSuccess, 
            payload: { 
                buys: response?.data.data.transactions, 
                total: response?.data.data.total 
            } 
        });
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getMyBuysFailure });
    }
};

export const cleanMyBuys = () => (dispatch: Dispatch) => _cleanMyBuys(dispatch);
const _cleanMyBuys = (dispatch: Dispatch) => dispatch({ type: cleanMyBuysReducer });

export const getMyBuy = (id: string) => (dispatch: Dispatch) => _getMyBuy(id, dispatch);
const _getMyBuy = async (id: string, dispatch: Dispatch) => {
    try {
        dispatch({ type: getMyBuyRequest });

        const response = await axiosClient.get(`${api.transactions}/${id}`);

        dispatch({ type: getMyBuySuccess, payload: response?.data.data.transaction })

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getMyBuyFailure, payload: errorResponse?.code });
    }
};

export const cleanMyBuy = () => (dispatch: Dispatch) => _cleanMyBuy(dispatch);
const _cleanMyBuy = (dispatch: Dispatch) => dispatch({ type: cleanMyBuyReducer });

export const getRegions = () => (dispatch: Dispatch) => _getRegions(dispatch);
const _getRegions = async (dispatch: Dispatch) => {
    try {
        dispatch({ type: getRegionsRequest });

        const response = await axiosClient.get(`${api.users}/regions`);

        dispatch({ type: getRegionsSuccess, payload: response?.data.data.company });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getRegionsFailure });
    }
}

export const getAllCities = () => (dispatch: Dispatch) => _getAllCities(dispatch);
const _getAllCities = async (dispatch: Dispatch) => {
    try {
        dispatch({ type: getCitiesRequest });

        const response = await axiosClient.get(`${api.users}/cities/`);

        dispatch({ type: getCitiesSuccess, payload: response?.data.data.company });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getCitiesFailure });
    }
}

export const getCities = (region_id: number) => (dispatch: Dispatch) => _getCities(region_id, dispatch);
const _getCities = async (region_id: number, dispatch: Dispatch) => {
    try {
        dispatch({ type: getCitiesRequest });

        const response = await axiosClient.get(`${api.users}/cities/region/${region_id}`);

        dispatch({ type: getCitiesSuccess, payload: response?.data.data.city });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getCitiesFailure });
    }
}

export const getAllCommunes = () => (dispatch: Dispatch) => _getAllCommunes(dispatch);
const _getAllCommunes = async (dispatch: Dispatch) => {
    try {
        dispatch({ type: getCommunesRequest });

        const response = await axiosClient.get(`${api.users}/communes`);

        dispatch({ type: getCommunesSuccess, payload: response?.data.data.company });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getCommunesFailure });
    }
}

export const getCommunes = (city_id: number) => (dispatch: Dispatch) => _getCommunes(city_id, dispatch);
const _getCommunes = async (city_id: number, dispatch: Dispatch) => {
    try {
        dispatch({ type: getCommunesRequest });

        const response = await axiosClient.get(`${api.users}/communes/city/${city_id}`);

        dispatch({ type: getCommunesSuccess, payload: response?.data.data.company });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getCommunesFailure });
    }
}

export const patchResidence = (formData: ResidenceProps) => (dispatch: Dispatch, getState: GetState) => _patchResidence(formData, dispatch, getState);
const _patchResidence = async (formData: ResidenceProps, dispatch: Dispatch, getState: GetState) => {
    try {
        const userId = getState().auth.user?._id;

        dispatch({ type: patchResidenceRequest });

        const body = JSON.stringify({ residence: formData });

        const response = await axiosClient.patch(`${api.users}/${userId}`, body);

        dispatch({ type: patchResidenceSuccess, payload: response?.data?.data.user});

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: patchResidenceFailure });
    }
}

export const cleanProfileFetching = () => (dispatch: Dispatch) => _cleanProfileFetching(dispatch);
const _cleanProfileFetching = (dispatch: Dispatch) => {
    dispatch({ type: cleanEditUser });
    dispatch({ type: cleanResidenceFetching });
};

export const getFavorites = (page: number = 1, limit: number = 20) => (dispatch: Dispatch) => _getFavorites(page, limit, dispatch);
const _getFavorites = async (page: number = 1, limit: number = 20, dispatch: Dispatch) => {
    try {
        dispatch({ type: getFavoritesRequest })

        const response = await axiosClient.get(`${api.publications}/likes`);

        const { data: { liked_publications } } = response?.data;

        const likedPublications = liked_publications.map((publication: any) => ({ ...publication, liked: true }));
        dispatch({ 
            type: getFavoritesSuccess, 
            payload: {
                favorites: likedPublications,
                total: response?.data?.total
            }
        });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getFavoritesFailure })

    }
}

export const cleanFavorites = () => (dispatch: Dispatch) => _cleanFavorites(dispatch);
const _cleanFavorites = (dispatch: Dispatch) => dispatch({ type: cleanFavoritesReducer });

export const setFavorites = (data: any) => (dispatch: Dispatch) => _setFavorites(data, dispatch);
const _setFavorites = (data: any, dispatch: Dispatch) => dispatch({ type: setFavoritesReducer, payload: data });

export const likePublication = (id: string) => (dispatch: Dispatch) => _likePublication(id, dispatch);
const _likePublication = async (id: string, dispatch: Dispatch) => {
    try {
        dispatch({ type: likePublicationRequest });

        await axiosClient.post(`${api.publications}/${id}/likes`);

        dispatch({ type: likePublicationSuccess });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: likePublicationFailure });
    }
};

export const dislikePublication = (id: string) => (dispatch: Dispatch) => _dislikePublication(id, dispatch);
const _dislikePublication = async (id: string, dispatch: Dispatch) => {
    try {
        dispatch({ type: dislikePublicationRequest });

        await axiosClient.delete(`${api.publications}/${id}/likes`);

        dispatch({ type: dislikePublicationSuccess });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: dislikePublicationFailure });
    }
};

export const cleanLikedPublication = () => (dispatch: Dispatch) => _cleanLikedPublication(dispatch);
const _cleanLikedPublication = (dispatch: Dispatch) => dispatch({ type: cleanLikePublicationReducer });

export const getCreditData = (id: string) => (dispatch: Dispatch) => _getCreditData(id, dispatch);
const _getCreditData = async (id: string, dispatch: Dispatch) => {
    try {
        dispatch({ type: getCreditDataRequest });

        const response = await axiosClient.get(`${api.credits}/credit-requests/transaction/${id}`);

        dispatch({ type: getCreditDataSuccess, payload: response?.data?.data.credit_requests[0] });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getCreditDataFailure });
    }
};

export const getPayments = (idTransaction: string) => (dispatch: Dispatch) => _getPayments(idTransaction, dispatch);
const _getPayments = async (idTransaction: string, dispatch: Dispatch) => {
    try {
        dispatch({ type: getPaymentsRequest });

        const response = await axiosClient.get(`${api.payments}/transaction/${idTransaction}`);

        dispatch({ type: getPaymentsSuccess, payload: response?.data?.data.payments });
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getPaymentsFailure });
    }
};

export const cleanPayments = () => (dispatch: Dispatch) => _cleanPayments(dispatch);
const _cleanPayments = (dispatch: Dispatch) => dispatch({ type: cleanPaymentsReducer });

export const postPaymentDocument = (formData: any) => (dispatch: Dispatch, getState: GetState) => _postPaymentDocument(formData, dispatch, getState);
export const _postPaymentDocument = async (formData: any, dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: postPaymentDocumentRequest });

        const response = await axiosClient.post(`${api.payments}/files`, formData);

        const paymentCode = getState().profile.payments[0]?.code;

        dispatch({ type: postPaymentDocumentSuccess, payload: {
            url: response?.data?.data.file.path,
            code: paymentCode,
            payment_method: "vale-vista"
        } });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: postPaymentDocumentFailure });
    }
};


export const postPayment = (documentData: any, id: string) => (dispatch: Dispatch) => _postPayment(documentData, id, dispatch)
const _postPayment = async (documentData: any, id: string, dispatch: Dispatch) => {
  try {
    dispatch({ type: postPaymentRequest });

    const body = JSON.stringify(documentData);

    const response = await axiosClient.post(`${api.payments}/payment-processes/${id}`, body);

    dispatch({ type: postPaymentSuccess, payload: response?.data?.data.payment_process});
} catch (error: any) {
    const errorResponse = error?.response?.data?.error;
    console.log(errorResponse?.code);
    catch401(errorResponse?.code,dispatch);
    dispatch({ type: postPaymentFailure, payload: errorResponse?.code });
  }
};

export const cleanPayment = () => (dispatch: Dispatch) => _cleanPayment(dispatch);
const _cleanPayment = (dispatch: Dispatch) => dispatch({ type: cleanPaymentReducer });

export const setProfilePublication = (publication: any) => (dispatch: Dispatch) => _setProfilePublication(publication, dispatch);
const _setProfilePublication = (publication: any, dispatch: Dispatch) => dispatch({type: setPublication, payload: publication});

export const getSchedules = (date_from: string, date_to: string, page: number = 1, limit: number = 20) => (dispatch: Dispatch) => _getSchedules(date_from, date_to, page, limit, dispatch)
const _getSchedules = async (date_from: string, date_to: string, page: number = 1, limit: number = 20, dispatch: Dispatch) => {
    try {
        dispatch({ type: getSchedulesRequest });
        
        const response = await axiosClient.get(`${api.transactions}/inspection-schedules?date_from=${date_from}&date_to=${date_to}&page=${page}&limit=${limit}`);

        dispatch({ type: getSchedulesSuccess, payload: response?.data?.data});
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getSchedulesFailure, payload: errorResponse?.code });
    }
};

export const cleanSchedules = () => (dispatch: Dispatch) => _cleanSchedules(dispatch);
const _cleanSchedules = (dispatch: Dispatch) => dispatch({ type: cleanSchedulesReducer });

export const putTransferPublication = (idPublication: string, idUser: string) => (dispatch: Dispatch) => _putTransferPublication(idPublication, idUser, dispatch)
const _putTransferPublication = async (idPublication: string, idUser: string, dispatch: Dispatch) => {
  try {
    dispatch({ type: putTransferPublicationRequest });
    
    const body = JSON.stringify({"user": idUser});

    await axiosClient.put(`${api.transactions}/transfer/${idPublication}`, body);

    dispatch({ type: putTransferPublicationSuccess});
} catch (error: any) {
    const errorResponse = error?.response?.data?.error;
    console.log(errorResponse?.code);
    catch401(errorResponse?.code,dispatch);
    dispatch({ type: putTransferPublicationFailure, payload: errorResponse?.code });
  }
};

export const cleanTransferPublication = () => (dispatch: Dispatch) => _cleanTransferPublication(dispatch);
const _cleanTransferPublication = (dispatch: Dispatch) => dispatch({type: cleanTransferPublicationReducer});

export const getConcessionary = (id: string) => (dispatch: Dispatch) => _getConcessionary(id, dispatch);
const _getConcessionary = async (id: string, dispatch: Dispatch) => {
    try {
        dispatch({ type: getConcessionaryRequest });

        const response = await axiosClient.get(`${api.users}/dealerships/${id}`);

        dispatch({ type: getConcessionarySuccess, payload: response?.data?.data.dealership });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getConcessionaryFailure });
    }
}

export const cleanConcessionary = () => (dispatch: Dispatch) => _cleanConcessionary(dispatch);
const _cleanConcessionary = (dispatch: Dispatch) => dispatch({type: cleanConcessionaryReducer});

export const getBranches = (id: string, flow: string = "transfer") => (dispatch: Dispatch) => {
    return _getBranches(id, flow, dispatch);
};
const _getBranches = async (id: string, flow: string, dispatch: Dispatch) => {
    try {
        if(flow == "transfer"){
            dispatch({ type: getBranchesTransferRequest });
        }else{
            dispatch({ type: getBranchesRequest });
        }

        const response = await axiosClient.get(`${api.users}/branchs/dealership/${id}`);

        if(flow == "transfer"){
            dispatch({ type: getBranchesTransferSuccess, payload: response?.data?.data?.branch});
        }else{
            dispatch({ type: getBranchesSuccess, payload: response?.data?.data?.branch});
        }
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        if(flow == "transfer"){
            dispatch({ type: getBranchesTransferFailure, payload: errorResponse?.code });
        }else{
            dispatch({ type: getBranchesFailure, payload: errorResponse?.code });
        }
    }
};

export const cleanBranchesTransfer = () => (dispatch: Dispatch) => _cleanBranchesTransfer(dispatch);
const _cleanBranchesTransfer = (dispatch: Dispatch) => dispatch({type: cleanBranchesTransferReducer});

export const cleanBranches = () => (dispatch: Dispatch) => _cleanBranches(dispatch);
const _cleanBranches = (dispatch: Dispatch) => dispatch({type: cleanBranchesReducer});

export const getBranch = (id: string) => (dispatch: Dispatch) => _getBranch(id, dispatch)
const _getBranch = async (id: string, dispatch: Dispatch) => {
    try {
        dispatch({ type: getBranchRequest });

        const response = await axiosClient.get(`${api.users}/branchs/${id}`);

        dispatch({ type: getBranchSuccess, payload: response?.data?.data?.branch});
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        catch401(errorResponse?.code,dispatch);
        console.log(errorResponse?.code);
        dispatch({ type: getBranchFailure, payload: errorResponse?.code });
    }
};

export const cleanBranch = () => (dispatch: Dispatch) => _cleanBranch(dispatch);
const _cleanBranch = (dispatch: Dispatch) => dispatch({type: cleanBranchReducer});

export const addBranch = (branchData: any) => (dispatch: Dispatch) => _addBranch(branchData, dispatch);
const _addBranch = async (branchData: any, dispatch: Dispatch) => {
    try {
        dispatch({ type: addBranchRequest });
        const body = JSON.stringify(branchData);

        const response = await axiosClient.post(`${api.users}/branchs`, body);

        dispatch({ type: addBranchSuccess, payload: response?.data.data.user});
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        catch401(errorResponse?.code,dispatch);
        console.log(errorResponse?.code);
        dispatch({ type: addBranchFailure, payload: errorResponse?.code });
    }
};

export const cleanAddBranch = () => (dispatch: Dispatch) => _cleanAddBranch(dispatch);
const _cleanAddBranch = (dispatch: Dispatch) => dispatch({type: cleanAddBranchReducer});

export const editBranch = (id: string, body: any) => (dispatch: Dispatch) => _editBranch(id, body, dispatch);
const _editBranch = async (id: string, body: any, dispatch: Dispatch) => {
    try {
        dispatch({ type: editBranchRequest });

        const bodyReq = JSON.stringify(body);
        
        const response = await axiosClient.put(`${api.users}/branchs/${id}`, bodyReq);

        dispatch({ type: editBranchSuccess, payload: response?.data?.data.user});
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        catch401(errorResponse?.code,dispatch);
        console.log(errorResponse?.code);
        dispatch({ type: editBranchFailure, payload: errorResponse?.code });
    }
};

export const cleanEditBranch = () => (dispatch: Dispatch) => _cleanEditBranch(dispatch);
const _cleanEditBranch = (dispatch: Dispatch) => dispatch({type: cleanEditBranchReducer});

export const deleteBranch = (id: string) => (dispatch: Dispatch) => _deleteBranch(id, dispatch);
const _deleteBranch = async (id: string, dispatch: Dispatch) => {
    try {
        dispatch({ type: deleteBranchRequest });

        await axiosClient.delete(`${api.users}/branchs/${id}`);

        dispatch({ type: deleteBranchSuccess });
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        catch401(errorResponse?.code,dispatch);
        console.log(errorResponse?.code);
        dispatch({ type: deleteBranchFailure });
    }
}

export const cleanDeleteBranch = () => (dispatch: Dispatch) => _cleanDeleteBranch(dispatch);
const _cleanDeleteBranch = (dispatch: Dispatch) => dispatch({type: cleanDeleteBranchReducer});

export const getSellers = (id: string, type: string, flow: string = "transfer") => (dispatch: Dispatch) => _getSellers(id, type, flow, dispatch)
const _getSellers = async (id: string, type: string, flow: string, dispatch: Dispatch) => {
    try {
        if(flow === "transfer"){
            dispatch({ type: getSellersTransferRequest });
        }else{
            dispatch({ type: getSellersRequest });
        }
        let response;

        if(type === "branch"){
            response = await axiosClient.get(`${api.users}/by-branch/${id}`);
        }else{
            response = await axiosClient.get(`${api.users}/by-dealership/${id}`);
        }

        if(flow === "transfer"){
            dispatch({ type: getSellersTransferSuccess, payload: response?.data?.data?.users});
        }else{
            dispatch({ type: getSellersSuccess, payload: response?.data?.data?.users});
        }
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        if(flow === "transfer"){
            dispatch({ type: getSellersTransferFailure, payload: errorResponse?.code });
        }else{
            dispatch({ type: getSellersFailure, payload: errorResponse?.code });
        }
  }
};

export const cleanSellersTransfer = () => (dispatch: Dispatch) => _cleanSellersTransfer(dispatch);
const _cleanSellersTransfer = (dispatch: Dispatch) => dispatch({type: cleanSellersTransferReducer});

export const cleanSellers = () => (dispatch: Dispatch) => _cleanSellers(dispatch);
const _cleanSellers = (dispatch: Dispatch) => dispatch({type: cleanSellersReducer});

export const addSeller = (seller: any, branchId: string) => (dispatch: Dispatch) => _addSeller(seller, branchId, dispatch);
const _addSeller = async (seller: any, branchId: string, dispatch: Dispatch) => {
    try {
        dispatch({ type: addSellerRequest });
        const body = JSON.stringify({
            ...seller,
            "company": process.env.REACT_APP_COMPANY,
            "branch": branchId
        });

        const response = await axiosClient.post(`${api.users}/by-admin`, body);

        dispatch({ type: addSellerSuccess, payload: response?.data.data.user});
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        catch401(errorResponse?.code,dispatch);
        console.log(errorResponse?.code);
        dispatch({ type: addSellerFailure, payload: errorResponse?.code });
    }
};

export const cleanAddSeller = () => (dispatch: Dispatch) => _cleanAddSeller(dispatch);
const _cleanAddSeller = (dispatch: Dispatch) => dispatch({type: cleanAddSellerReducer});

export const editSeller = (id: string, body: any) => (dispatch: Dispatch) => _editSeller(id, body, dispatch);
const _editSeller = async (id: string, body: any, dispatch: Dispatch) => {
    try {
        dispatch({ type: editSellerRequest });
        
        const bodyReq = JSON.stringify(body);

        const response = await axiosClient.patch(`${api.users}/by-admin/${id}`, bodyReq);

        dispatch({ type: editSellerSuccess, payload: response?.data?.data.user});
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: editSellerFailure, payload: errorResponse?.code });
    }
};

export const cleanEditSeller = () => (dispatch: Dispatch) => _cleanEditSeller(dispatch);
const _cleanEditSeller = (dispatch: Dispatch) => dispatch({type: cleanEditSellerReducer});

export const deleteSeller = (id: string) => (dispatch: Dispatch) => _deleteSeller(id, dispatch);
const _deleteSeller = async (id: string,dispatch: Dispatch) => {
    try {
        dispatch({ type: deleteSellerRequest });

        await axiosClient.delete(`${api.users}/by-admin/${id}`);

        dispatch({ type: deleteSellerSuccess });
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: deleteSellerFailure });
    }
}

export const cleanDeleteSeller = () => (dispatch: Dispatch) => _cleanDeleteSeller(dispatch);
const _cleanDeleteSeller = (dispatch: Dispatch) => dispatch({type: cleanDeleteSellerReducer});

export const getMyOffers = (page?: string, limit?: string) => (dispatch: Dispatch) => _getMyOffers(page, limit, dispatch)
const _getMyOffers = async (page: string = "1", limit: string = "20", dispatch: Dispatch) => {
  try {
    dispatch({ type: getMyOffersRequest });

    const response = await axiosClient.get(`${api.publications}/with-offers?offer=received&page=${page}&limit=${limit}`);

    dispatch({ type: getMyOffersSuccess, payload: response?.data.data?.publications});
  } catch (error: any) {
    const errorResponse = error?.response?.data?.error;
    console.log(errorResponse);
    catch401(errorResponse?.code,dispatch);
    dispatch({ type: getMyOffersFailure, payload: errorResponse?.code });
  }
};

export const cleanGetMyOffers = () => (dispatch: Dispatch) => _cleanGetMyOffers(dispatch);
const _cleanGetMyOffers = (dispatch: Dispatch) => dispatch({ type: cleanGetMyOffersReducer });